import React, { FC, ReactNode, useState } from 'react';
import { Subtitle } from '../typography';
import {
  NavigationAndActionArrowDown,
  NavigationAndActionArrowUp,
} from '../icons';
import {
  AccordionDiv,
  AccordionTitle,
  AccordionContent,
  Arrow,
  AddButton,
  IconsWrapper,
} from './styled';
import { Flex } from '../flex';

export interface AccordionProps {
  title: string;
  icon?: ReactNode;
  addButton?: ReactNode;
  onAdd?: () => void;
  onOpen: () => void;
}

export const Accordion: FC<AccordionProps> = ({
  title,
  icon,
  addButton,
  onAdd,
  children,
  onOpen,
}) => {
  const [isOpen, setIsOpen] = useState(false);

  const toggleOpen = () => {
    if (!isOpen) {
      onOpen();
    }
    setIsOpen(!isOpen);
  };

  return (
    <AccordionDiv active={isOpen} alignItems="stretch">
      <Flex flexDirection="row" justifyContent="space-between">
        <AccordionTitle active={isOpen} onClick={toggleOpen}>
          {icon}
          <Subtitle>{title}</Subtitle>
        </AccordionTitle>
        <IconsWrapper>
          {addButton && <AddButton onClick={onAdd} />}
          <Arrow onClick={toggleOpen} active={isOpen}>
            {isOpen ? (
              <NavigationAndActionArrowUp />
            ) : (
              <NavigationAndActionArrowDown />
            )}
          </Arrow>
        </IconsWrapper>
      </Flex>
      <AccordionContent isOpen={isOpen}>{children}</AccordionContent>
    </AccordionDiv>
  );
};
